import {
  getPowerTypeGroup,
  POWER_TYPE_QUICK_FILTERS,
  PowerTypeQuickFilter
} from "@/src/constants/vehicle";

/**
 * Which buckets to render, in fixed [Bensiini, Sähkö, Hybridi] order, restricted to
 * buckets that have at least one matching listing (AC2).
 */
export const getVisibleBuckets = (
  rawFuelTypes: (string | undefined)[]
): PowerTypeQuickFilter[] => {
  const present = new Set(
    rawFuelTypes
      .map((fuelType) => getPowerTypeGroup(fuelType))
      .filter((bucket): bucket is PowerTypeQuickFilter => bucket !== null)
  );

  return POWER_TYPE_QUICK_FILTERS.filter((bucket) => present.has(bucket));
};

/**
 * A bucket is active if any currently stored fuelType (including orphans not present
 * in the live option list) normalizes to it.
 */
export const isBucketActive = (
  bucket: PowerTypeQuickFilter,
  fuelType: string[] | undefined
): boolean =>
  (fuelType ?? []).some((value) => getPowerTypeGroup(value) === bucket);

/**
 * Toggling off removes every stored value that normalizes to this bucket (including
 * orphans). Toggling on unions in the bucket's currently-present raw values.
 */
export const toggleBucket = (
  bucket: PowerTypeQuickFilter,
  presentRawValues: (string | undefined)[],
  fuelType: string[] | undefined
): string[] => {
  const current = fuelType ?? [];

  if (isBucketActive(bucket, current)) {
    return current.filter((value) => getPowerTypeGroup(value) !== bucket);
  }

  const membersToAdd = presentRawValues.filter(
    (value): value is string =>
      value !== undefined && getPowerTypeGroup(value) === bucket
  );

  return [...new Set([...current, ...membersToAdd])];
};
